// 3D-perspective court preview driven by configurable colours.
// Renders an SVG basketball-style court tilted in 3D space.
export default function CourtPreview({ base, keyColor, border, line, logo, className = "", flat = false }) {
  const svg = (
    <svg viewBox="0 0 400 220" className="h-full w-full" preserveAspectRatio="xMidYMid meet">
      <rect x="0" y="0" width="400" height="220" fill={border} />
      <rect x="18" y="18" width="364" height="184" fill={base} />
      {/* keys */}
      <rect x="18" y="74" width="70" height="72" fill={keyColor} stroke={line} strokeWidth="2.5" />
      <rect x="312" y="74" width="70" height="72" fill={keyColor} stroke={line} strokeWidth="2.5" />
      {/* outer boundary */}
      <rect x="18" y="18" width="364" height="184" fill="none" stroke={line} strokeWidth="3" />
      {/* centre line + circle */}
      <line x1="200" y1="18" x2="200" y2="202" stroke={line} strokeWidth="2.5" />
      <circle cx="200" cy="110" r="34" fill="none" stroke={line} strokeWidth="2.5" />
      {/* key arcs */}
      <path d="M88 74 A36 36 0 0 1 88 146" fill="none" stroke={line} strokeWidth="2.5" />
      <path d="M312 74 A36 36 0 0 0 312 146" fill="none" stroke={line} strokeWidth="2.5" />
      {/* three-point arcs */}
      <path d="M18 44 A96 96 0 0 1 18 176" fill="none" stroke={line} strokeWidth="2.5" />
      <path d="M382 44 A96 96 0 0 0 382 176" fill="none" stroke={line} strokeWidth="2.5" />
      {/* centre logo */}
      {logo ? (
        <image href={logo} x="176" y="86" width="48" height="48" preserveAspectRatio="xMidYMid slice" clipPath="circle(24px at 24px 24px)" />
      ) : (
        <text x="200" y="116" textAnchor="middle" fontFamily="monospace" fontSize="13" letterSpacing="2" fill={line} opacity="0.55">SPEEDY RESURFACING</text>
      )}
    </svg>
  );

  if (flat) return <div className={className}>{svg}</div>;

  return (
    <div className={`relative ${className}`} style={{ perspective: "1400px" }}>
      <div
        className="relative w-full transition-transform duration-500"
        style={{ transform: "rotateX(52deg) rotateZ(-2deg)", transformStyle: "preserve-3d" }}
      >
        <div className="rounded-md overflow-hidden shadow-[0_60px_120px_rgba(0,0,0,0.9)] ring-1 ring-white/10">
          {svg}
        </div>
        <div className="absolute inset-0 rounded-md pointer-events-none"
             style={{ background: "linear-gradient(160deg, rgba(255,255,255,0.10), transparent 45%)" }} />
      </div>
    </div>
  );
}
